import React, { useState } from "react";
import { Button, Form, Accordion } from "react-bootstrap";
// import Arrow from "../assets/img/drop-down-arrow.png";
import "./dropdownSpecifications.css";

export default function DropdownSpecifications({
  selectedData,
  addLabel,
  removeLabel,
}) {
  const [open, setOpen] = useState(true);
  const [activeId, setActiveId] = useState("0");

  const handleChange = (label) => () => {
    if (selectedData.indexOf(label) > -1) removeLabel(label);
    else addLabel(label);
  };

  function toggleActive(id) {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  // console.log(selectedData)

  return (
    <div className="container">
      <div className="group-button">
       <div className="btn btn-secondary dropdown-toggle"> <Button onClick={() => setOpen(!open)}>استانداردهای دنده</Button></div>
      </div>
      <div className="drop-main">
        <div className={` drop-custom ${open ? "drop-custom-show" : ""}`}>
          <div className="accordion">
            <Accordion defaultActiveKey={activeId}>
              <div
                className={
                  activeId === "0" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("0")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="0"
                  >
                   ATF
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="0">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="ATF II"
                        id="ATF II"
                        onChange={handleChange("ATF II")}
                        checked={selectedData.indexOf("ATF II") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="ATF III G"
                        id="ATF III G"
                        onChange={handleChange("ATF III G")}
                        checked={selectedData.indexOf("ATF III G") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="ATF III H"
                        id="ATF III H"
                        onChange={handleChange("ATF III H")}
                        checked={selectedData.indexOf("ATF III H") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="ATF VI"
                        id="ATF VI"
                        onChange={handleChange("ATF VI")}
                        checked={selectedData.indexOf("ATF VI") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="ATF HP"
                        id="ATF HP"
                        onChange={handleChange("ATF HP")}
                        checked={selectedData.indexOf("ATF HP") > -1}
                      />
                         <Form.Check
                        type="checkbox"
                        label="ATF ULV"
                        id="AATF ULV"
                        onChange={handleChange("ATF ULV")}
                        checked={selectedData.indexOf("ATF ULV") > -1}
                      />
                         <Form.Check
                        type="checkbox"
                        label="ALISON TES -295"
                        id="ALISON TES -295"
                        onChange={handleChange("ALISON TES -295")}
                        checked={selectedData.indexOf("ALISON TES -295") > -1}
                      />
                    
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

        

            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}
